if (Object.keys(confTheme) === 0) {
  confTheme = $infosBase.data('theme-conf');
}

// Variáveis
const $sectionsHome = $('#sections-home');
const svgIcons = $infosBase.data('svg-icons');
const collectionsHome = $infosBase.data('collections');
const brandsHome = $infosBase.data('brands');
const categoriasHome = $infosBase.data('categories');
const pagesHome = $infosBase.data('pages');
const postsHome = $infosBase.data('blog');

// Retorna um ícone
function getSvgIcon(icon) {
  if (svgIcons[icon]) {
    return svgIcons[icon]['svg'];
  }
  return icon;
}

// Popula as seções da home
function populateSectionsHome(sections) {
  if ($sectionsHome.length > 0 && sections && sections.length > 0) {
    $sectionsHome.html('');
    sections.forEach((section) => {
      // Slide
      if (section.type === 'slide') {
        populateSlide($sectionsHome, section);
      }
      // Banners
      if (section.type === 'banners') {
        populateBanners($sectionsHome, section);
      }
      // Catálogo (Carrossel)
      if (section.type === 'catalogo') {
        populateCatalogo($sectionsHome, section);
      }
      // Catálogo (Grade)
      if (section.type === 'catalogo_grid') {
        populateCatalogoGrid($sectionsHome, section);
      }
      // Catálogo (Promoção)
      if (section.type === 'catalogo_promo') {
        populateCatalogoPromo($sectionsHome, section);
      }
      // Destaques
      if (section.type === 'destaques') {
        populateDestaques($sectionsHome, section);
      }
      // Marcas
      if (section.type === 'marcas') {
        populateMarcas($sectionsHome, section);
      }
      // Categorias
      if (section.type === 'categorias') {
        populateCategorias($sectionsHome, section);
      }
      // Depoimentos
      if (section.type === 'depoimentos') {
        populateDepoimentos($sectionsHome, section);
      }
      // Blog
      if (section.type === 'blog') {
        populateBlog($sectionsHome, section);
      }
      // Sobre
      if (section.type === 'sobre') {
        populateSobre($sectionsHome, section);
      }
    });
  }
}

// Retorna o índice ou informações de uma seção dinâmica da home
function getSecHomeInfos(secID, rIndex = false) {
  const homeSections = confTheme.sections;
  if (rIndex) {
    let secIndexReturn = false;
    homeSections.forEach((secItem, secIndex) => {
      if (secItem.id == secID) {
        secIndexReturn = secIndex;
      }
    });
    return secIndexReturn;
  } else {
    const section = homeSections.filter((secItem) => secItem.id == secID);
    if (section.length > 0) {
      return section[0];
    }
  }
  return false;
}

// Altera a ordem das seções
if (previewMode) {
  function changeSectionsHomeOrder() {
    const orders = confTheme['sections'].map((secItem) => {
      return {
        id: secItem.id,
        order: secItem.order,
      };
    });
    orders.forEach((orderItem) => {
      const $section = $('#' + orderItem.id);
      const order = parseInt(orderItem.order);
      if ($section.length > 0) {
        $section[0].style.setProperty('--order', order);
        $section[0].style.setProperty('order', order);
      }
    });
  }
  $root.on(confEvtDefault + ' lp-evt-sections-home-order', changeSectionsHomeOrder);
}

// Adiciona ou atualiza uma seção
if (previewMode) {
  function updSectionHome(secID, action) {
    const section = getSecHomeInfos(secID);
    if (section) {
      // Slide
      if (section.type === 'slide') {
        populateSlide($sectionsHome, section, action);
      }
      // Banners
      if (section.type === 'banners') {
        populateBanners($sectionsHome, section, action);
      }
      // Depoimentos
      if (section.type === 'depoimentos') {
        populateDepoimentos($sectionsHome, section, action);
      }
      // Destaques
      if (section.type === 'destaques') {
        populateDestaques($sectionsHome, section, action);
      }
      // Categorias
      if (section.type === 'categorias') {
        populateCategorias($sectionsHome, section, action);
      }
      // Coleção (Carrossel)
      if (section.type === 'catalogo') {
        populateCatalogo($sectionsHome, section, action);
      }
      // Coleção (Grade)
      if (section.type === 'catalogo_grid') {
        populateCatalogoGrid($sectionsHome, section, action);
      }
      // Coleção (Promoção)
      if (section.type === 'catalogo_promo') {
        populateCatalogoPromo($sectionsHome, section, action);
      }
      // Marcas
      if (section.type === 'marcas') {
        populateMarcas($sectionsHome, section, action);
      }
      // Blog
      if (section.type === 'blog') {
        populateBlog($sectionsHome, section, action);
      }
      // Sobre
      if (section.type === 'sobre') {
        populateSobre($sectionsHome, section, action);
      }
      setTimeout(() => {
        $root.trigger('update-emitters');
      }, 250);
    } else {
      console.log('Seção (' + secID + ') não encontrada.');
    }
  }
  $root.on('shstore-add', function () {
    updSectionHome(sectionHomeCur, 'insert');
  });
  $root.on('shstore-upd', function () {
    updSectionHome(sectionHomeCur, 'update');
  });
}

// Remove uma seção
if (previewMode) {
  function remSectionHome(secID) {
    const $section = $('#' + secID);
    if ($section.length > 0) {
      $section.remove();
    }
  }
  $root.on('shstore-rem', function () {
    remSectionHome(sectionHomeCur);
  });
}

// Atualiza todas as seções de catálogo (Coleção)
function populateAllCatalogos() {
  if (confTheme.sections && confTheme.sections.length > 0) {
    confTheme.sections.forEach((section) => {
      if (section.type === 'catalogo') {
        populateCatalogo($sectionsHome, section, 'update');
      } else if (section.type === 'catalogo_grid') {
        populateCatalogoGrid($sectionsHome, section, 'update');
      } else if (section.type === 'catalogo_promo') {
        populateCatalogoPromo($sectionsHome, section, 'update');
      }
    });
  }
  if ($('.pag-catalogo .prod-bl-wrp').length > 0) {
    // Grid classes
    let gridClassDesktop;
    let gridClasTablet;
    let gridClasMobile;
    const showFilters = confTheme['products']['catalog-filters-show'] == '1';
    if (showFilters) {
      gridClassDesktop = {
        3: 'grid-4',
        4: 'grid-4',
        5: 'grid-3',
        6: 'grid-2-4',
      };
      gridClasTablet = {
        2: 'grid-md-6',
        3: 'grid-md-6',
        4: 'grid-md-6',
      };
      gridClasMobile = {
        1: 'grid-sm-12 grid-xs-12',
        2: 'grid-sm-12 grid-xs-12',
      };
    } else {
      gridClassDesktop = {
        3: 'grid-4',
        4: 'grid-3',
        5: 'grid-2-4',
        6: 'grid-2',
      };
      gridClasTablet = {
        2: 'grid-md-6',
        3: 'grid-md-4',
        4: 'grid-md-3',
      };
      gridClasMobile = {
        1: 'grid-sm-12 grid-xs-12',
        2: 'grid-sm-6 grid-xs-6',
      };
    }
    const prodColsDesktop = confTheme['products']['prod-bl-cols-desktop'] || 5;
    const prodColsTablet = confTheme['products']['prod-bl-cols-tablet'] || 3;
    const prodColsMobile = confTheme['products']['prod-bl-cols-mobile'] || 2;
    const $prodsBl = $('.pag-catalogo .prod-bl-wrp');
    function prependClass(sel, strClass) {
      const $el = $(sel);
      let classes = $el.attr('class');
      classes = strClass + ' ' + classes;
      $el.attr('class', classes);
    }
    $prodsBl.removeClass(
      'grid-2 grid-2-4 grid-3 grid-4 grid-md-3 grid-md-4 grid-md-6 grid-sm-6 grid-sm-12 grid-xs-6 grid-xs-12',
    );
    prependClass(
      $prodsBl,
      `${gridClassDesktop[prodColsDesktop]} ${gridClasTablet[prodColsTablet]} ${gridClasMobile[prodColsMobile]} prod-bl-wrp`,
    );
  }
  setTimeout(() => {
    $root.trigger('update-emitters');
  }, 250);
}
$root.on('lp-evt-populate-catalogos', populateAllCatalogos);

function mountProdBl(product, opts, carousel = false) {
  // Grid
  const prodColsDesktop = confTheme['products']['prod-bl-cols-desktop'] || 5;
  const prodColsTablet = confTheme['products']['prod-bl-cols-tablet'] || 3;
  const prodColsMobile = confTheme['products']['prod-bl-cols-mobile'] || 2;
  let gridDesktopClass = '';
  let gridTabletClass = '';
  let gridMobileClass = '';
  if (!carousel) {
    gridDesktopClass = opts['grid-desktop'];
    gridTabletClass = opts['grid-tablet'];
    gridMobileClass = opts['grid-mobile'];
  }

  // Estilo do bloco
  const catBlStyle = confTheme['products']['prod-bl-style'];
  const prodBlInfosAlignClass = confTheme['products']['prod-bl-infos-align'];
  let prodBlImgFmt = confTheme['products']['prod-bl-img-format'] || 'default';
  prodBlImgFmt = 'prod-bl-img-' + prodBlImgFmt;
  const prodBlBtnShow = confTheme['products']['prod-bl-btn-show'] == 1;
  const prodBlBtnWrpClass = prodBlBtnShow ? 'prod-bl-with-btn' : '';
  const prodBlBtnShowClass = !prodBlBtnShow ? 'd-none' : '';
  const prodBlBtnClass = confTheme['products']['prod-bl-btn-class'];
  const prodBlBtnStyle = confTheme['general'][prodBlBtnClass + '-style'];
  const prodBlBtnTxt = confTheme['products']['prod-bl-btn-txt'] || 'Comprar Agora';
  const prodBlBtn = prodBlBtnShow
    ? `<div class="prod-bl-btns ${prodBlBtnShowClass}">
    <button class="btn ${prodBlBtnClass} ${prodBlBtnStyle}">${prodBlBtnTxt}</button>
  </div>`
    : '';

  // Estilo imagem lateral
  const prodBlSide = opts['prod-bl-side'] ?? '';

  // Aviso fora de estoque
  const outOfStockTagShow = confTheme['products']['out-of-stock-show'] == 1;
  let outOfStockTagClass = '';
  let outOfStockTag = '';
  if (product['in_stock'] == '0' && outOfStockTagShow) {
    outOfStockTagClass = 'out-of-stock';
    const outOfStockTxt = confTheme['products']['out-of-stock-txt'] ?? 'Esgotado';
    outOfStockTag =
      '<span class="prod-bl-out-of-stock-wrp"><span class="prod-bl-out-of-stock">' + outOfStockTxt + '</span></span>';
  }

  // Imagem
  const thumbWidths = {
    3: 400,
    4: 300,
    5: 235,
    6: 200,
  };
  const thumbWidth = thumbWidths[prodColsDesktop] ?? 300;
  const prodBlImgThumb = getThumb(product['image'], thumbWidth, 0, 'auto');

  // Imagem hover
  let imgHover = '';
  if (confTheme['products']['prod-bl-img-hover'] == 1 && product['image_hover'] != '') {
    const prodBlImgHoverThumb = getThumb(product['image_hover'], thumbWidth, 0, 'auto');
    imgHover = `<img class="hover" src="${prodBlImgHoverThumb}" alt="${product['title']}" width="100%" height="${thumbWidth}px">`;
  }

  // Selos
  let flags = '';
  if (product['flags'].length > 0) {
    flags += '<div class="prod-bl-flags top-left">';
    product['flags'].forEach((flag) => {
      const flagBgColor = flag['bg-color'] ? flag['bg-color'] : confTheme['products']['styles']['prod-bl-flag-color'];
      const flagTxtColor = flag['txt-color'] ? flag['txt-color'] : '#fff';
      flags += `<span class="prod-bl-flag" style="--bg-color: ${flagBgColor}; --txt-color: ${flagTxtColor}">${flag['text']}</span>`;
    });
    flags += '</div>';
  }

  // Avaliações
  let stars = '';
  if (confTheme['products']['prod-bl-rating-show'] == '1') {
    stars += '<div class="star-rating prod-bl-stars">';
    for (let i = 1; i <= 5; i++) {
      const starActive = product['rating'] >= i ? 'active' : '';
      stars += `<label class="${starActive}">${getSvgIcon('star')}</label>`;
    }
    stars += `<span>(${product['rating_total']})</span>`;
    stars += '</div>';
  }

  // Preço antigo
  const oldPrice = product['old_price'] > 0 ? `<span class="old">R$ ${formatMoneyBR(product['old_price'])}</span>` : '';

  // Parcelamento
  let prodBlInstallments = '';
  const prodBlParcShow = confTheme['products']['prod-bl-parc-show'] == '1';
  if (prodBlParcShow && product['installments'] && product['installments'].length > 0) {
    let lastParc = product['installments'][product['installments'].length - 1];
    if (confTheme['products']['prod-bl-parc-sem-juros'] == '1') {
      const lastParcSemJurosArr = product['installments'].filter((item) => item['sem_juros'] == 1);
      lastParc = lastParcSemJurosArr[lastParcSemJurosArr.length - 1];
    }
    const parcTxtDefault = 'Até **{X}x** de **R$ {V}**';
    let parcTxt = confTheme['products']['prod-bl-parc-txt'] ?? parcTxtDefault;
    parcTxt = mdParse(parcTxt, true);
    parcTxt = parcTxt.replace('{X}', lastParc['parcela']);
    parcTxt = parcTxt.replace('{V}', formatMoneyBR(lastParc['valor']));
    const parcIcon = confTheme['products']['prod-bl-parc-icon'] == '1' ? getSvgIcon('card-outline') : '';
    prodBlInstallments = '<div class="prod-bl-parc">' + parcIcon + '<span>' + parcTxt + '</span></div>';
  }

  // Desconto pix
  let prodBlPixDisc = '';
  const prodBlPixDiscShow = confTheme['products']['prod-bl-pix-show'] == '1';
  if (prodBlPixDiscShow && parseFloat(product['pix_discount']) > 0) {
    const valDisc = (parseFloat(product['pix_discount']) * product['sale_price']) / 100;
    const newVal = product['sale_price'] - valDisc;
    const pixTxtDefault = 'ou **R$ {V}** no pix';
    let pixTxt = confTheme['products']['prod-bl-pix-txt'] ?? pixTxtDefault;
    pixTxt = mdParse(pixTxt, true);
    pixTxt = pixTxt.replace('{V}', formatMoneyBR(newVal));
    pixTxt = pixTxt.replace('{D}', product['pix_discount']);
    const pixIcon = confTheme['products']['prod-bl-pix-icon'] == '1' ? getSvgIcon('pix-outline') : '';
    prodBlPixDisc = '<div class="prod-bl-pix">' + pixIcon + '<span>' + pixTxt + '</span></div>';
  }

  // Carrinho AJAX
  let cartJaxClass = '';
  let $cartJaxBtn = '';
  if (confTheme['products']['prod-bl-cart-ajax'] == '1') {
    const cartJaxBtnTxt = confTheme['products']['prod-bl-cart-ajax-btn-txt'] || 'Adicionar';
    const cartJaxBtnClass = confTheme['products']['prod-bl-cart-ajax-btn-class'] || 'btn-white';
    const cartJaxBtnKeepMb = confTheme['products']['prod-bl-cart-ajax-keep-mb'] == 1 ? '' : 'btn-fade';
    cartJaxClass = 'cart-ajax';
    $cartJaxBtn = `<div class="cart-ajax-btn-wrp ${cartJaxBtnKeepMb}"><button class="btn ${cartJaxBtnClass} cart-ajax-btn"><span class="cart-ajax-btn-icon">${getSvgIcon(
      'cart_plus',
    )}</span><span class="cart-ajax-btn-txt">${cartJaxBtnTxt}</span></button></div>`;
  }

  // HTML do bloco
  let itemHTML = `
  <a href="#" class="${gridDesktopClass} ${gridTabletClass} ${gridMobileClass} prod-bl-wrp ${prodBlBtnWrpClass} ${catBlStyle} ${prodBlSide} ${outOfStockTagClass}">
    <div class="prod-bl">
      <figure class="img prod-bl-img ${prodBlImgFmt}">
        <img src="${prodBlImgThumb}" alt="${product['title']}" width="100%" height="${thumbWidth}px">
        ${imgHover}
        ${flags}
        ${$cartJaxBtn}
      </figure>
      <div class="prod-bl-infos ${prodBlInfosAlignClass}">
        ${stars}
        <div class="prod-bl-title">${product['title']}</div>
        <div class="prod-bl-price">
          ${oldPrice}
          <span class="new">R$ ${formatMoneyBR(product['sale_price'])}</span>
        </div>
        ${prodBlPixDisc}
        ${prodBlInstallments}
      </div>
      ${prodBlBtn}
      ${outOfStockTag}
    </div>
  </a>`;

  return itemHTML;
}
